(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-leia-sound-status.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-leia-sound-status.js');
"use strict";


const {
  useEffect,
  useState,
  useMemo
} = React;
const useLeiaSoundStatus = _ref => {
  let {
    ticketInfo
  } = _ref;
  const {
    hasSound,
    hasSoundDefaultOn,
    type
  } = ticketInfo;
  const logger = svs.ticketgames.ticketUtility.logger;
  const {
    soundEnabled,
    usersSavedSoundStatus,
    setUsersSavedSoundStatus
  } = svs.ticketgames.ticketUtility.utils.useSoundEnabled({
    ticketInfo
  });
  const [soundStatus, setSoundStatus] = useState(soundEnabled);
  const [receivedFirstSoundStatus, setReceivedFirstSoundStatus] = useState(false);
  const handleGameComplete = () => {
    if (hasSound) {
      logger.info("SoundStatus: ".concat(soundStatus, ", DefaultSoundStatus: ").concat(hasSoundDefaultOn, ", UsersSavedSoundStatus: ").concat(usersSavedSoundStatus, ", GameCode: ").concat(type));
    }
  };
  const handleSoundStatus = e => {
    logger.info("sound changed to ".concat(e.detail, " for ").concat(type));
    if (receivedFirstSoundStatus) {
      setUsersSavedSoundStatus(e.detail);
    }
    setSoundStatus(e.detail);
    setReceivedFirstSoundStatus(true);
  };
  const notifySoundStatus = soundStatus => {
    var _gameloaderHelper$ins, _gameloaderHelper$ins2;
    (_gameloaderHelper$ins = gameloaderHelper.instance) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins = _gameloaderHelper$ins.notifierProxy) === null || _gameloaderHelper$ins === void 0 || (_gameloaderHelper$ins2 = _gameloaderHelper$ins.notifySoundStatus) === null || _gameloaderHelper$ins2 === void 0 || _gameloaderHelper$ins2.call(_gameloaderHelper$ins, soundStatus);
  };
  const soundEvents = useMemo(() => [{
    eventName: 'HAS_CLAIMED',
    handler: handleGameComplete
  }, {
    eventName: 'SOUND_STATUS',
    handler: handleSoundStatus
  }], [handleGameComplete, handleSoundStatus]);
  useEffect(() => {
    if (!receivedFirstSoundStatus) {
      if (soundEnabled !== soundStatus) {
        logger.warn("Sound status is ".concat(soundStatus, " for ").concat(type, ", but expected ").concat(soundEnabled, ". hasSound: ").concat(hasSound, ", hasSoundDefaultOn: ").concat(hasSoundDefaultOn, ", usersSavedSoundStatus: ").concat(usersSavedSoundStatus));
      }
    }
  }, [soundStatus, receivedFirstSoundStatus]);
  useEffect(() => {
    soundEvents.forEach(evt => addEventListener(evt.eventName, evt.handler));
    return () => {
      soundEvents.forEach(evt => removeEventListener(evt.eventName, evt.handler));
    };
  }, [soundStatus, receivedFirstSoundStatus]);
  return {
    soundStatus,
    notifySoundStatus,
    soundEvents
  };
};
setGlobal('svs.ticketgames.ticketUtility.utils.useLeiaSoundStatus', useLeiaSoundStatus);

 })(window);